import React from 'react';

export function StatusDot({ state = 'muted', pulse = false, label, className = '', ...rest }) {
  const dot = (
    <span
      className={['sp-dot', 'sp-dot--' + state, pulse && 'sp-dot--pulse', className].filter(Boolean).join(' ')}
      {...rest}
    />
  );
  if (!label) return dot;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 'var(--fs-body-sm)', color: 'var(--text-muted)' }}>
      {dot}{label}
    </span>
  );
}
